<template>
  <div class="insight-filter-card" @click="handleClick">
    <div class="insight-filter-card-title">{{ cardInfor.title }}</div>
    <div class="insight-filter-card-content">
      <div class="insight-filter-card-content-main">
        {{ cardInfor.main }}
      </div>
      <div class="insight-filter-card-content-list">
        <div v-for="(item, index) in cardInfor.list" :key="index">
          {{ item }}
        </div>
      </div>
    </div>
    <div class="insight-filter-card-tags">
      <span v-for="(item, index) in cardInfor.tags" :key="index">{{
        item
      }}</span>
    </div>
    <div class="insight-filter-card-footer">
      <span><img :src="see"  /><span>{{cardNum && cardNum.pageView || 0}}</span></span>
      <span><img :src="like" /><span>{{cardNum && cardNum.like || 0}}</span></span>
    </div>
  </div>
</template>
<script>
 import {
    mapGetters
  } from "vuex";
import like from '@/assets/img/like.png'
import see from '@/assets/img/see.png'
export default {
  data() {
    return {
      like, see
    };
  },
  props: {
    cardInfor: Object,
  },
  components: {},
  computed: {
    ...mapGetters('insight', ['insightList']),
    cardNum () {
      return this.insightList.find(i =>i._id === this.cardInfor._id)
    }
  },
  methods: {
    handleClick: function () {
      window.open(this.cardInfor.url);
    },
  },
};
</script>

<style lang="scss">
.insight-filter-card {
  background: #ffffff;
  border: 1px solid rgba(234, 234, 234, 1);
  box-shadow: 2px 2px 14px 2px rgba(5, 5, 5, 0.06);
  border-radius: 6px;
  width: 370px;
  height: 280px;
  &:hover {
    cursor: pointer;
  }
  .insight-filter-card-title {
    background-image: url("/static/img/card.png");
    border-radius: 6px 6px 0 0;
    height: 88px;
    padding: 24px;
    text-align: left;
    font-size: 24px;
    color: #ffffff;
    letter-spacing: 0;
    font-weight: 700;
    line-height: 40px;
  }
  .insight-filter-card-content {
    padding: 16px 24px 0 24px;
    > .insight-filter-card-content-main {
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      display: -webkit-box;
      word-break: break-all;
      -webkit-box-orient: vertical;
      font-size: 14px;
      color: #333333;
      letter-spacing: 0;
      line-height: 22px;
      font-weight: 400;
      height: 44px;
    }
    > .insight-filter-card-content-list {
      margin-top: 10px;
      font-size: 12px;
      color: #999999;
      letter-spacing: 0;
      line-height: 18px;
      font-weight: 400;
      height: 36px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      >div {
       text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
    text-align: left;
      }
    }
  }
  > .insight-filter-card-tags {
        display: flex;
    padding: 0 24px;
    margin-top: 19px;
    > span {
      background: #f8f8f8;
    border-radius: 2px;
      font-size: 12px;
      color: #333333;
      letter-spacing: 0;
      text-align: center;
      line-height: 24px;
      font-weight: 400;
      padding: 0 12px;
    margin-right: 12px;
    }
  }
  >.insight-filter-card-footer {
    margin-top: 12px;
    display: flex;
    padding: 0 24px;
    justify-content: flex-end;
    align-items: center;
    >span {
      margin-left: 30px;
          display: flex;
    align-items: center;
      >img {
        width:20px;
      }
      >span {
 font-size: 12px;
    color: #999999;
    letter-spacing: 0;
    font-weight: 700;
    line-height: 20px;
    margin-left: 4px;
      }
    }
  }
}
</style>